import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";
import { OnboardingCtaComponent } from "@m19-board/containers/board-layout/board-sidebar/onboarding-cta.component";

@Component({
  selector: "app-start-free-test-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, OnboardingCtaComponent],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="promo"
      [title]="t('overlays.start_free_test_title')"
      [subtitle]="t('overlays.start_free_test_subtitle')"
    >
      <p overlayBody>{{ t("overlays.start_free_test_reason") }}</p>
      <app-onboarding-cta overlayCta />
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartFreeTestOverlayComponent {
  static readonly rule = OverlayRule.START_FREE_TEST;
}
